import hover from './timelines/hover';
import canvasHover from './timelines/canvas';
import loaderAnimation from './timelines/loaderAnimation';
import cursor from './timelines/cursor';
import { eventsListIn, eventsListOut } from './timelines/eventsListTransitions';

const animations = new Map();

animations.set('hover', hover);
animations.set('canvasHover', canvasHover);
animations.set('loader', loaderAnimation);
animations.set('eventsListIn', eventsListIn);
animations.set('cursor', cursor);
animations.set('eventsListIn', eventsListIn);
animations.set('eventsListOut', eventsListOut);

export default animations;



// WEBPACK FOOTER //
// ./src/scripts/animations.js